import {
  Drawer,
  Box,
  Toolbar,
  Typography,
  List,
  ListItem,
  darken,
  ListItemText,
  MenuList,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useStaticQuery, graphql } from "gatsby";
import { IconButton, Link } from "gatsby-theme-material-ui";
import React from "react";
import { Logo } from "./NavigationBar";
import slugify from "@sindresorhus/slugify";

const AppDrawer = ({ open, setOpen, navigationItems }) => {
  return (
    <Drawer open={open} onClose={() => setOpen(false)} variant="temporary">
      <Box>
        <Toolbar>
          <Box mr={1}>
            <IconButton onClick={() => setOpen(false)}>
              <Close />
            </IconButton>
          </Box>
          <Link to="/" color="textPrimary" style={{ textDecoration: "none" }}>
            <Logo />
          </Link>
        </Toolbar>

        <List style={{ display: "flex", flexDirection: "column" }}>
          <ListItem
            button
            style={{ fontWeight: "bold", paddingTop: 10, paddingBottom: 10 }}
            component={Link}
            to="/"
          >
            Насловна
          </ListItem>
          {navigationItems.group.map(({ fieldValue }) => (
            <ListItem
              button
              style={{
                fontWeight: "bold",
                paddingTop: 10,
                paddingBottom: 10,
                textTransform: "capitalize",
              }}
              component={Link}
              to={`/${slugify(fieldValue)}`}
            >
              {fieldValue}
            </ListItem>
          ))}

          {/* <ListItem button component={Link} to="/macedonia">
            <ListItemText primary="Македонија" />
          </ListItem>
          <ListItem button component={Link} to="/world">
            Свет
          </ListItem>
          <ListItem button component={Link} to="/politics">
            Политика
          </ListItem>
          <ListItem button component={Link} to="/business">
            Бизнес
          </ListItem>
          <ListItem button component={Link} to="/tech">
            Технологии
          </ListItem>
          <ListItem button component={Link} to="/science">
            Наука
          </ListItem>
          <ListItem button component={Link} to="/sport">
            Спорт
          </ListItem>
          <ListItem button component={Link} to="/travel">
            Пътуване
          </ListItem>
          <ListItem button component={Link} to="/culture">
            Култура
          </ListItem> */}
        </List>
      </Box>
    </Drawer>
  );
};
export default AppDrawer;
